var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm._l(_vm.serverConfig, function(server, index) {
        return _c(
          "article",
          {
            key: index,
            staticClass: "memcached-server"
          },
          [
            _c("header", [
              _c(
                "h3",
                [
                  _c("translate", [_vm._v("Memcached-Server")]),
                  _vm._v(" " + _vm._s(index + 1) + "\n                "),
                  _c("studip-icon", {
                    staticClass: "remove-server",
                    attrs: {
                      shape: "trash",
                      size: 24
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.removeServer($event, index)
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "col-4"
              },
              [
                _c(
                  "label",
                  {
                    attrs: {
                      for: "hostname-" + index
                    }
                  },
                  [_c("translate", [_vm._v("Hostname")])],
                  1
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    name: "servers[" + index + "][hostname]",
                    id: "hostname-" + index,
                    placeholder: "localhost"
                  },
                  domProps: {
                    value: server.hostname
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "col-2"
              },
              [
                _c(
                  "label",
                  {
                    attrs: {
                      for: "port-" + index
                    }
                  },
                  [_c("translate", [_vm._v("Port")])],
                  1
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    name: "servers[" + index + "][port]",
                    id: "port-" + index,
                    placeholder: "11211"
                  },
                  domProps: {
                    value: server.port
                  }
                })
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "add-server",
          on: {
            click: _vm.addServer
          }
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: "add",
              size: 20
            }
          }),
          _vm._v(" "),
          _c("translate", [_vm._v("Server hinzufügen")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }